module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.ac031a32.woff";